import React from 'react'
import './Intro.css'
import IntroData from '../../Data/Intro.json'

function Intro() {
    return (
        <div className="main-content-intro">
            <h1>{IntroData.title}</h1>
            <h3>{IntroData.subtitle}</h3>
            <p>{IntroData.tagline}</p>
            {/* <br />
            <span>
                {IntroData.tagline2.text}
                <a href={IntroData.tagline2.link}>{IntroData.tagline2.hyperlink}</a>
                {IntroData.tagline2.suffix}
            </span> */}
        </div>
    )
}

export default Intro
